import bilditBIcon from '../../assets/images/bildit-b-icon.png';
import bannerReorderDemo from '../../assets/images/CMA-ChangeBanner_Reorder.mp4';
import StepProgress from './StepProgress';
import '../../assets/css/Onboarding.css';

/**
 * Shared Sign Up / Log In chrome: full-bleed media band + white form panel.
 */
function OnboardingAuthLayout({
  showProgress = false,
  activeStep = 1,
  heading,
  subtext,
  children,
}) {
  return (
    <div className="onboarding-page">
      <div className="onboarding-media-slot" aria-hidden="true">
        <video
          className="onboarding-media-hero"
          src={bannerReorderDemo}
          autoPlay
          muted
          loop
          playsInline
          disablePictureInPicture
        />
      </div>
      <div className="onboarding-panel">
        <div className="onboarding-panel-body">
          <div className="onboarding-panel-col">
            <a
              href="https://www.bildit.co"
              className="onboarding-brand-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={bilditBIcon} alt="BILDIT" className="onboarding-logo" />
            </a>
            {showProgress ? (
              <>
                <StepProgress activeStep={activeStep} />
                <p className="onboarding-step-label">Step {activeStep} of 4</p>
              </>
            ) : null}
            <h1 className="onboarding-heading">{heading}</h1>
            {subtext ? <p className="onboarding-subtext">{subtext}</p> : null}
          </div>
          <div className="onboarding-panel-col onboarding-panel-col--form">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnboardingAuthLayout;
